<template>
    <div class="restore-password-code">
        <UIInputCode
            :label="$t('restore.securityVerification')"
            comment="Enter the 6 digit code from 2FA"
            :full="true"
            :fieldOne="form.fieldOne"
            :fieldTwo="form.fieldTwo"
            :fieldThree="form.fieldThree"
            :fieldFour="form.fieldFour"
            :fieldFive="form.fieldFive"
            :fieldSix="form.fieldSix"
            @field="onChangeField"
        />

        <img
            class="restore-password-code__status"
            v-show="getStatusIsShow"
            :src="getStatus"
            alt="status"
        />

        <div class="restore-password-code__resend">
            <span v-if="resendSuccess" class="restore-password-code__resend-success">
                {{ $t('restore.resendCodeSent') }}
            </span>
            <button
                v-else
                class="restore-password-code__resend-btn"
                :disabled="resendLoading || resendCooldown > 0"
                @click="onResend"
            >
                {{ resendCooldown > 0
                    ? $t('restore.resendCode') + ' (' + resendCooldown + ')'
                    : $t('restore.resendCode') }}
            </button>
        </div>
    </div>
</template>

<script>
import UIInputCode from "@/components/ui/input/code.vue";

import {COMPONENTS} from "@/components/shared/restore-pasword/content/content.vue";

import Api from "@/api/api";

const api = new Api();

const STATUS_IMAGES = {
    error: require("@/assets/images/shared/restore-password/code/error.svg"),
    success: require("@/assets/images/shared/restore-password/code/success.svg"),
    default: "",
};

const CODE_LENGTH = 6;

export default {
    name: "RestorePasswordCode",
    components: {
        UIInputCode,
    },
    props: {
        form: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            status: "",
            resendLoading: false,
            resendSuccess: false,
            resendCooldown: 0,
            cooldownTimer: null,
        };
    },
    computed: {
        getStatus() {
            return STATUS_IMAGES[this.status];
        },

        getStatusIsShow() {
            return this.status;
        },

        getCode() {
            const {
                fieldOne,
                fieldTwo,
                fieldThree,
                fieldFour,
                fieldFive,
                fieldSix,
            } = this.form;

            return `${fieldOne}${fieldTwo}${fieldThree}${fieldFour}${fieldFive}${fieldSix}`;
        },

        getCodeIsCompleted() {
            return this.getCode.length === CODE_LENGTH;
        },
    },
    beforeDestroy() {
        if (this.cooldownTimer) clearInterval(this.cooldownTimer);
    },
    methods: {
        async onChangeField(field) {
            this.$emit("code", field);

            if (this.getCodeIsCompleted) {
                this.$emit("next", COMPONENTS.password);
            }
        },

        async onResend() {
            if (!this.form.email || this.resendLoading || this.resendCooldown > 0) return;
            try {
                this.resendLoading = true;
                await api.resetPassword(this.form.email);
                this.resendSuccess = true;
                this.startCooldown(60);
                setTimeout(() => { this.resendSuccess = false; }, 3000);
            } catch (e) {
                // silent
            } finally {
                this.resendLoading = false;
            }
        },

        startCooldown(seconds) {
            this.resendCooldown = seconds;
            if (this.cooldownTimer) clearInterval(this.cooldownTimer);
            this.cooldownTimer = setInterval(() => {
                this.resendCooldown--;
                if (this.resendCooldown <= 0) {
                    clearInterval(this.cooldownTimer);
                    this.cooldownTimer = null;
                }
            }, 1000);
        },
    },
};
</script>

<style lang="scss">
.restore-password-code {
    display: flex;
    flex-direction: column;
    align-items: center;
    grid-row-gap: 40px;

    &__resend {
        display: flex;
        justify-content: center;
    }

    &__resend-btn {
        background: none;
        border: none;
        padding: 0;
        cursor: pointer;
        font-size: 14px;
        color: var(--color-primary, #238fd9);
        text-decoration: underline;

        &:disabled {
            color: #aaa;
            cursor: default;
            text-decoration: none;
        }
    }

    &__resend-success {
        font-size: 14px;
        color: #27ae60;
    }
}
</style>
